import React, {useContext} from 'react';
import {useSelector} from "react-redux";
import RightSection from "./RightSection";
import FiltersReview from "./FiltersReview";
import PathReviewAccount from "./PathReviewAccount";
import "./reviewAccountStyle.scss"
import TableViewReviewAccount from "./TableView";
import CustomReviewAccountTable from "./CustomReviewAccountTable";
import ExcelReviewDownloadButton from "./ExcelReviewDownloadButton";
import {SetPrintDataContext} from "../../Pages";
import {useNavigate} from "react-router-dom";

const Index = () => {
  const data = useSelector(s => s.reviewAccountReducer)
  const setprint = useContext(SetPrintDataContext);
  let navigate = useNavigate();

  const GoToPrintPage = () => {
    let sendData
    if (data.myData.isOverall){
      sendData = {
        type: "ReviewAccountsPrint",
        data: data.myData,
        title: "مرور حساب ها"
      };
    }else {
      sendData = {
        type: "ReviewAccountsPrintTwo",
        data: data.myData,
        title: "مرور حساب ها"
      };
    }
    setprint(sendData);
    navigate("/factorprint");
  }

  return (
    <div className={'reviewAccountStyle'}>
      <div className={'page__section'}>
        <RightSection/>
        <div className={'bg-white transition'} style={{padding:'10px'}}>
          <FiltersReview/>
          <PathReviewAccount/>
          <div>
            {data.myData.isOverall ? <TableViewReviewAccount/> :
              <CustomReviewAccountTable/>}

            <div className={'d-flex'}>
              <ExcelReviewDownloadButton/>

              <div className={'width__100 mx-2'}>
                {data?.myData.data.length > 0 &&
                  <button className={'btn btn__secondary_purple p-2 font__size__10'}
                          onClick={GoToPrintPage}>پرینت</button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
